import * as Sentry from '@sentry/react';

const normalizeEnvValue = (value: string | undefined): string =>
  (value || '').replace(/\\r|\\n|\r|\n/g, '').trim();

const SENTRY_DSN = normalizeEnvValue(process.env.REACT_APP_SENTRY_DSN);
const SENTRY_ENVIRONMENT = normalizeEnvValue(process.env.REACT_APP_SENTRY_ENVIRONMENT) || process.env.NODE_ENV || 'development';
const SENTRY_RELEASE = normalizeEnvValue(process.env.REACT_APP_SENTRY_RELEASE);
const SENTRY_TRACES_SAMPLE_RATE = Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0');

export const observabilityEnabled = (): boolean => Boolean(SENTRY_DSN);

export const initFrontendObservability = (): void => {
  if (!SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE || undefined,
    tracesSampleRate: Number.isFinite(SENTRY_TRACES_SAMPLE_RATE) ? SENTRY_TRACES_SAMPLE_RATE : 0,
    sendDefaultPii: false,
  });
};

export const captureFrontendException = (error: unknown, extra?: Record<string, unknown>): void => {
  if (!observabilityEnabled()) return;
  Sentry.captureException(error, {
    extra,
  });
};

export const captureFrontendMessage = (message: string, extra?: Record<string, unknown>): void => {
  if (!observabilityEnabled()) return;
  Sentry.captureMessage(message, {
    level: 'error',
    extra,
  });
};
